import '../jquery.plugin';
import '../jquery.timeentry';
import '../new_candidate_details';
import '../public_rendering/job_page';
import '../wcag_share_button';
import './admin/availability_field';

if (window.jQuery?.fn?.jquery && !window.jQuery.rails) {
  require('jquery-ujs');
}

$(() => {
  const content = $('#content');
  const $datepicker = $('.datepicker');

  if ($datepicker.length > 0) {
    $datepicker.datepicker({ dateFormat: 'dd/mm/yy' });
  }

  if (content.length) {
    $('.sidebar-wrapper').css('top', content.offset().top + 24);
  }
});
